export const secondSinceEpoch = () => Math.floor( Date.now() / 1000 );
